import {
  useCreateBalanceAdjustment,
  useGetBalanceAdjustment,
} from 'api-hooks/transactions/balance-adjustment';
import { KIND, Notification } from 'baseui/notification';
import { NavigationRoutes } from 'common/constants';
import LoadingComponent from 'components/common/loading';
import ErrorViewComponent from 'components/elements/error-view-component';
import FetchWrapperComponent from 'components/elements/fetch-wrapper-component';
import useApprovalableEdit from 'hooks/use-approvalable-edit';
import { DetailContainer } from 'legacy-modules/styles';
import { useRouter } from 'next/router';
import { NavigationProps } from 'types';

import BalanceAdjustmentForm from './components/form';

export type BalanceAdjustmentsViewParams = {
  id: string;
};

export default function BalanceAdjustmentsView(
  props: NavigationProps<NavigationRoutes.BalanceAdjustmentsView>,
) {
  const { query } = useRouter();
  const id = query?.id as string;
  const { data, error, isLoading, isFetching, refetch } =
    useGetBalanceAdjustment({
      id,
    });

  const { mutateAsync, error: errorMutate } = useCreateBalanceAdjustment();

  const balanceAdjustment = data?.data;

  const onResolve = useApprovalableEdit('balance-adjustments');

  return (
    <FetchWrapperComponent
      onRetry={refetch}
      loadingComponent={<LoadingComponent />}
      error={error}
      errorComponent={
        <DetailContainer>
          <ErrorViewComponent refetch={refetch} />
        </DetailContainer>
      }
      isLoading={isLoading || isFetching}
      component={
        <>
          {!!errorMutate && !!errorMutate.message && (
            <>
              <Notification
                overrides={{
                  Body: { style: { width: 'auto', wordBreak: 'break-all' } },
                }}
                kind={KIND.negative}
                closeable
              >
                {() => errorMutate.message}
              </Notification>
            </>
          )}
          <BalanceAdjustmentForm
            {...props}
            balanceAdjustment={balanceAdjustment}
            onSubmit={async (input, form) => {
              const result = await mutateAsync(input);
              onResolve(result);
              return result.data;
            }}
          />
        </>
      }
    />
  );
}
